import { useCallback, useRef } from 'react'

import { BottomSheetModal } from '@gorhom/bottom-sheet'

export const useDailyInspirationRecentResponseSheet = () => {
  const dailyInspirationRecentResponseSheetRef = useRef<BottomSheetModal>(null)

  const openBottomModal = useCallback(() => {
    dailyInspirationRecentResponseSheetRef.current?.present()
  }, [])

  const closeDailyInspirationRecentResponseSheet = useCallback(() => {
    dailyInspirationRecentResponseSheetRef.current?.close()
  }, [dailyInspirationRecentResponseSheetRef])

  const openDailyInspirationRecentResponseSheet = () => openBottomModal()

  return {
    dailyInspirationRecentResponseSheetRef,
    closeDailyInspirationRecentResponseSheet,
    openDailyInspirationRecentResponseSheet
  }
}
